import {Module} from "vuex";
import {RootState} from "@/vuex/store";
import actions from './actions';
import mutations from "./mutations";
import getters from "./getters";
import InspectionsState from "@/vuex/modules/inspections-module/state";

const module: Module<InspectionsState, RootState> = {
    state: new InspectionsState(),
    actions,
    mutations,
    getters,
}

export default module;
